import { render, staticRenderFns } from "./QA.vue?vue&type=template&id=e27710b4&scoped=true"
import script from "./QA.vue?vue&type=script&lang=js"
export * from "./QA.vue?vue&type=script&lang=js"
import style0 from "./QA.vue?vue&type=style&index=0&id=e27710b4&prod&lang=scss"
import style1 from "./QA.vue?vue&type=style&index=1&id=e27710b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e27710b4",
  null
  
)

export default component.exports